var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgForm = function SvgForm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#0C0C0C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.4,
    strokeWidth: 1.5,
    d: "M7.692 6.467h4.616m-4.616 2.6h4.616m-4.616 2.6H10M6.538 3h6.924C14.312 3 15 3.776 15 4.733v9.534C15 15.224 14.31 16 13.46 16H6.538C5.688 16 5 15.224 5 14.267V4.733C5 3.776 5.69 3 6.538 3"
  })));
};
export default SvgForm;